<template>
    <div class="m-order">
        <div class="m-user"><user-info/></div>

        <div class="order-view">
            <div class="header"></div>

            <div class="order-pannel" v-if="JSON.stringify(order_list) != '{}'">
                <div class="group-item" v-for="(list,key) in order_list" :key="'s-' + key">
                    <div class="group-pannel">
                        <div class="pannel-body"></div>
                        <div class="pannel-content">

                            <div class="shop-name">
                                <div class="name">
                                    <p>{{ shop_dic[key] ? shop_dic[key].name : ''}}</p>
                                </div>
                            </div>

                            <ul class="item-list">
                                <li v-for="(item,index) in list" :key="index">

                                    <div class="item-detail">
                                        <div class="goods-detail">
                                            <div class="goods-wrapper">
                                                <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.num"></game-item></div>
                                            </div>  
                                        </div>                                   
                                        
                                        <div class="price-info">
                                            <h6 class="item-name">{{ item.giftName }}</h6>
                                            <div class="now">实付<em class="icon-m3b"></em><span>{{ item.cost }}</span></div>                                           
                                        </div>
                                    </div>

                                    <div class="u-btn detail" @click="call_detail(item)">订单详情 ></div>
                                </li>
                            </ul>
                        </div>
                    </div>                    
                </div>
            </div>

            <div class="order-pannel" v-else>
                <div class="notice">
                    <h5>您还没有相关订单</h5>
                    <p><router-link to="/"> 可以去集市看看有没有想买的~</router-link></p>                
                </div>
            </div>

            <rec-view :rec_list="rec_list"></rec-view>
        </div>
    </div>
</template>

<script>
import shop_group from '@/components/shopgroup.js'

export default {
    data (){
        return {
            order_list : {},
            rec_list : [],
            shop_dic : shop_group.order_dic,
        }
    },
    mounted (){
        this.render();
    },
    methods : {
        render (){
            this.$get(ajax_url_map.order_list,{
                success : (data) => {
                    this.order_list = data.data;
                }
            })
        },
        call_detail (item){
            let player_list = item.cutUser ? [{ name :  item.cutUser , discount : item.cut}] : [];
            this.$order_modal({ payTime : item.payTime , player_list : player_list });
        },
    },
}
</script>

<style lang="scss" scoped>
.m-order{
    padding-top: 604px;
}

.m-user{
    width: 750px;
    height: 48px;
    line-height: 48px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-userinfo.png);
}

.order-view{
    width: 750px;
    // min-height: 2382px;
    padding-bottom: 200px;
    margin: 0 auto;
    background-image: url(~@/assets/images/task/bg-task.png);
    background-repeat: repeat-y;

    .header{
        width: 750px;
        height: 156px;
        margin: 0 auto 30px;
        background-image: url(~@/assets/images/order/header-order.png);
    }

    /* notice */
    .notice{
        padding: 40px 0;
        text-align: center;

        h5{
            font-size: 40px;
            margin-bottom: 20px;
            color: #aa754f;            
        }

        a{
            color: #ad7239;
        }
    }
 
    .goods-detail{
        .goods-wrapper{
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            width: 118px;
            height: 118px;
            background-image: url(~@/assets/images/shop/bg-item.png);
        }

        .goods-pic{
            width: 69px;
            height: 69px;
            border: 2px solid #ccae62;
        }
    }

    .u-btn.detail{
        color: #a0938a;
        text-decoration: underline;
    }

}

.group-item{

    position: relative;
    padding-top: 30px;
    margin-bottom: 28px;

    &::before{
        display: block;
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 483px;
        height: 44px;
        background-image: url(~@/assets/images/basket/shop-top.png);
    }

    .group-pannel{
        position: relative;
        width: 690px;       
        margin: 0 auto;
        background: url(~@/assets/images/task/pannel-head.png) center top no-repeat,
                    url(~@/assets/images/task/pannel-footer.png) center bottom no-repeat;
        background-size: 100% auto;

        .pannel-body{
            position: absolute;
            left:0;
            top:38px;
            bottom:38px;
            width:100%;
            background: url(~@/assets/images/task/pannel-body.png) left top repeat-y;
            background-size: 100% auto;          
        }

        .pannel-content{
            position: relative;
            min-height: 400px;
            padding: 25px 24px 22px;
            color: #7f572d;

            b{
                color: #d33d27;
            }

            span{
                color: #a0938a;

                b{
                    color: #d33d27;
                }                
            }

            ul{
                padding: 0 22px;

                li{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 14px;
                }
                
            }

        }

        .shop-name{
            display: flex;

            .check-box{
                margin-right: 14px;
            }

            .name p{
                font-size: 28px;
                font-weight: 700;
                color: #7f572d;
            }
        }

        .item-detail{
            display: flex;
            justify-content: space-between;
            align-items: center;

            .price-info{
                margin-left: 20px;

                .item-name{
                    margin-bottom: 10px;
                    font-weight: 700;
                    color: #7f572d;
                    font-size: 24px;
                }

                .icon-m3b {
                    display: inline-block;
                    width: 26px;
                    height: 26px;
                    background-image: url(~@/assets/images/icon-m3b.png);
                    // vertical-align: middle;
                }

                .low {
                    color: #683d1e;
                }

                .now {
                    color: #683d1e;
                }

                .now span {
                    font-size: 28px;
                    font-weight: 700;
                    color: #d33d27;
                }

                .p-before {
                    padding-left: 8px;
                    color: #ad7239;
                    text-decoration: line-through;
                }

            }
        }

    }   
}

</style>